import * as React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form'

import * as UserActions from 'store/user/actions'

import SnackbarService from 'services/snackbars'

import SuccessModal from 'components/SuccessModal'
import { RouteComponentProps, withRouter } from 'react-router'
import Content from './content'

interface INativeProps {
  oobCode: string | null
}
interface IReduxStateProps {
  password: string
  confirmPassword: string
}

interface IReduxActionsProps {
  UserLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxActionsProps {}
interface IProps
  extends INativeProps,
    IReduxProps,
    InjectedFormProps,
    RouteComponentProps {}
interface IState {
  loading: boolean
  showModal: boolean
}

class ResetPassword extends React.Component<IProps, IState> {
  state: IState = {
    loading: false,
    showModal: false
  }

  openModal = () => {
    this.setState({ showModal: true })
  }

  closeModal = () => {
    this.setState({ showModal: false })
  }

  passwordIsValid = () => {
    const pwdLen = 6
    const { password, confirmPassword } = this.props
    if (!password) {
      throw new Error('Enter a password')
    } else if (password.length < pwdLen) {
      throw new Error(`Password must be ${pwdLen} letters at least`)
    } else if (password !== confirmPassword) {
      throw new Error('Passwords must match')
    }
    return true
  }

  doReset = () => {
    const { UserLib, password, oobCode } = this.props

    try {
      this.passwordIsValid()
    } catch (e) {
      SnackbarService.showSnackbar(e, 'error')
      return
    }
    UserLib.resetPassword(
      oobCode,
      password,
      () => {
        this.openModal()
      },
      e => SnackbarService.showSnackbar(e, 'error')
    )
  }

  render() {
    const { loading, showModal } = this.state

    return showModal ? (
      <SuccessModal open={true} subtitle="Password updated" />
    ) : (
      <Content loading={loading} doReset={this.doReset} />
    )
  }
}

const formConnector = reduxForm({ form: 'reset-password' })
const selector = formValueSelector('reset-password')

const mapStateToProps = (state): IReduxStateProps => ({
  password: selector(state, 'password'),
  confirmPassword: selector(state, 'confirmPassword')
})
const mapDispatchToProps = (dispatch): IReduxActionsProps => ({
  UserLib: bindActionCreators<any, any>(UserActions, dispatch)
})

const connector = connect(mapStateToProps, mapDispatchToProps)

const Connected: any = compose(
  formConnector,
  connector,
  withRouter
)(ResetPassword)

export default (props: INativeProps) => <Connected {...props} />



// WEBPACK FOOTER //
// ./src/pages/EmailHandler/ResetPassword/index.tsx